import { useState } from "react";
import { Loader2, Play } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ChoiceRow, Label } from "@/components/ProfileInputs";
import { DIFFICULTIES, XP_RATES } from "@/lib/quiz";

export function TopicSheet({ topic, onClose, onStart, busy }) {
  const [difficulty, setDifficulty] = useState("beginner");
  const [length, setLength] = useState(10);
  const available = topic ? (difficulty === "all" ? topic.total : topic.by_difficulty?.[difficulty] ?? topic.total) : 0;

  return (
    <Sheet open={!!topic} onOpenChange={(v) => !v && !busy && onClose()}>
      <SheetContent side="bottom" className="bg-[#0A0A0A] border-[#27272A] max-w-md mx-auto rounded-t-3xl px-5 pb-8" data-testid="quiz-topic-sheet">
        {topic && (
          <>
            <SheetHeader className="text-left mb-6">
              <SheetTitle className="font-display text-2xl uppercase tracking-tight" data-testid="quiz-topic-sheet-title">{topic.label}</SheetTitle>
              <SheetDescription className="text-[#A1A1AA]">
                {topic.total} questions · {topic.unseen} new to you
              </SheetDescription>
            </SheetHeader>
            <div className="space-y-6">
              <div>
                <Label>Difficulty</Label>
                <ChoiceRow testid="quiz-difficulty" options={DIFFICULTIES} value={difficulty} onChange={(v) => setDifficulty(v ?? difficulty)} className="grid grid-cols-2 gap-2" />
                <p className="text-xs text-[#A1A1AA] mt-2.5" data-testid="quiz-xp-note">
                  <span className="text-[#E50914] font-semibold">{difficulty === "all" ? "10–30" : `+${XP_RATES[difficulty]}`} XP</span> per correct answer, first time only
                </p>
              </div>
              <div>
                <Label>Length</Label>
                <ChoiceRow testid="quiz-length" options={[{ v: 10, l: "10 questions" }, { v: 5, l: "Quick 5" }]} value={length} onChange={(v) => setLength(v ?? length)} className="grid grid-cols-2 gap-2" />
              </div>
              {available < length && (
                <p className="text-xs text-[#A1A1AA]" data-testid="quiz-topup-note">
                  {available} questions at this level, so we'll add a few from the nearest level.
                </p>
              )}
              <button data-testid="quiz-start-button" onClick={() => onStart(topic.key, difficulty, length)} disabled={busy} className="btn-primary">
                {busy ? <Loader2 size={18} className="animate-spin" /> : <><Play size={16} /> Start quiz</>}
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
